import * as React from "react";
import { H2, Stack } from "atoms";
import styled from "@emotion/styled";
import { useOpenCalls } from "../api/useOpenCalls";
import { OpenCallCard } from "./OpenCallCard";
import { useUsersOpenCallVotes } from "../api/useUsersOpenCallVotes";
import { getOpenCallTag } from "../utils/getOpenCallTag";

function OpenCallVotingSuccessTasks() {
  const { data: openCalls } = useOpenCalls({
    isCommunityCuration: true,
    perPage: 4,
    status: "PUBLISHED",
  });
  const { data: myVotes } = useUsersOpenCallVotes();

  const availableForVote = React.useMemo(() => {
    if (!openCalls || !openCalls.data.length) {
      return [];
    }
    const myVoteIds = myVotes?.openCallIds ?? [];
    return openCalls.data.filter((openCall) => {
      const tag = getOpenCallTag(openCall);
      return tag === "Voting Open" && !myVoteIds.includes(openCall.id);
    });
  }, [openCalls, myVotes]);

  if (!availableForVote.length) {
    return null;
  }

  return (
    <Stack gap="sm">
      <H2 size="md" textAlign="center">
        Vote on More Open Calls
      </H2>

      <OpenCallCardGrid>
        {availableForVote.map((openCall) => (
          <SOpenCallCard key={openCall.id} openCall={openCall} linkToVote />
        ))}
      </OpenCallCardGrid>
    </Stack>
  );
}

const OpenCallCardGrid = styled.div(({ theme }) => ({
  display: "flex",
  flexWrap: "wrap",
  gap: theme.spacing.gap,
  justifyContent: "center",
  paddingBottom: "4rem",
}));
const SOpenCallCard = styled(OpenCallCard)({
  flex: "0 1 307px",
});

export { OpenCallVotingSuccessTasks };
